<template>
  <div class="wrapper">
    <div class="__container">
      <div class="form">
        <div class="logo">
          <router-link to="/login">
            <img src="@/assets/image/new_logo.png" />
          </router-link>
        </div>
        <div class="banner">
          <h1>Welcome back!</h1>
        </div>
        <div class="login_form">
          <label class="label">E-mail</label>
          <input
            type="text"
            placeholder="Type your E-mail"
            class="email"
            v-model="username"
            v-validate="'required'"
            :class="{ error_input: isErrorOnEmail }"
          />
          <div class="error-msg" v-show="isErrorOnEmail">
            {{ getErrorMsg.message | validate }}
          </div>
          <label class="label label-password">Password</label>
          <VuePassword
            type="password"
            placeholder="Type your Password"
            class="login-pass-input"
            v-validate="'required'"
            :strength="0"
            :disableStrength="false"
            v-model="password"
            :class="{ error_input: isErrorOnPassword }"
            @keyup.enter="logIn"
          />
          <div class="error-msg" v-show="isErrorOnPassword">
            {{ getErrorMsg.message | validate }}
          </div>
          <div class="error-msg" v-show="try_error_label">
            You tried so many time please wait
            {{ chance_time | validate }} seconds
          </div>
          <div class="forgot-password">
            <label>
              Forgot password?
              <router-link to="/forgot-password">
                <a class="signup">Reset</a>
              </router-link>
            </label>
          </div>
        </div>
        <div class="bottom">
          <div class="input-group remember-me-input">
            <input type="checkbox" id="rem" v-model="remember_me" />
            <label for="rem">Remember me</label>
          </div>
          <input type="button" @click="logIn" value="Sign In" class="signin" />
          <div class="loader" v-show="loading">
            <img src="@/assets/icons/loading_blue.gif" alt />
          </div>
          <label class="sign-in-up-option">Sign In with</label>
          <ul class="social-media-list">
            <li class="linkedin">
              <a @click.prevent="signInBySocial('linkedin')">
                <img src="@/assets/icons/linkedin.svg" alt />
                <span>Linked In</span>
              </a>
            </li>
            <li class="google">
              <a @click.prevent="signInBySocial('google')">
                <img src="@/assets/icons/google.svg" alt />
                <span>Google</span>
              </a>
            </li>
            <li class="facebook">
              <a @click.prevent="signInBySocial('facebook')">
                <img src="@/assets/icons/facebook.svg" alt />
                <span>Facebook</span>
              </a>
            </li>
            <li class="microsoft">
              <a @click.prevent="signInBySocial('microsoft')">
                <img src="@/assets/icons/microsoft_logo.png" width="20" alt />
                <span>Microsoft</span>
              </a>
            </li>
          </ul>

          <!-- <p class="dont-have-account">
            You don't have an account?
            <a href="/signup" @click.prevent="$router.push({ name: 'signup' })"
              >Sign up</a
            >
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VuePassword from "vue-password";
import moment from "moment";
import { eventBus } from "../main";
export default {
  name: "login",
  components: {
    VuePassword,
  },
  computed: {
    ...mapGetters([
      "getLocale",
      "getMessages",
      "getHelper",
      "getAlert",
      "getErrorMsg",
    ]),
    isInvited() {
      return !(
        this.$cookies.get("project-token") === null &&
        this.$cookies.get("employment-token") === null
      );
    },
    isPageReady() {
      // return true;
      return !(this.getMessages === null || this.getMessages === undefined);
    },

    pageContent() {
      return this.getMessages;
    },
    isErrorOnEmail() {
      return this.getErrorMsg.type === "email";
    },
    isErrorOnPassword() {
      return this.getErrorMsg.type === "password";
    },
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      try_error_label: false,
      chance_time: 30,
      timer: null,
      // emailFocussed : false,
      // passFocussed : false,
      remember_me: true,
    };
  },
  mounted() {
    let vm = this;
    vm.$store.commit("AUTH_REQUEST_ERROR", {});
    if (vm.$localStorage.get("logged_user_data")) {
      let user_data = JSON.parse(vm.$localStorage.get("logged_user_data"));
      sessionStorage.authToken = user_data.access_token;
      sessionStorage.siteAuthToken = user_data.consultified_token;
      sessionStorage.setItem("isLogedIn", true);
      sessionStorage.setItem("account_type", user_data.account_type);
      eventBus.$socket.emit("register", user_data.id);
      vm.$store.commit("AUTH_REQUEST", user_data);
      vm.$store.commit("INITIALIZE_APP_DATA", {
        token: user_data.access_token,
        id: user_data.id,
      });
      vm.$router.push({ path: "/" });
    }
  },
  methods: {
    ...mapActions([
      "INITIALIZE_APP_DATA",
      "AUTH_REQUEST",
      "LOADER_START",
      "LOADER_SUCCESS",
      "LOADER_MESSAGE",
      "LOADER_CLOSE",
      "AUTH_LINKEDIN_SIGNUP_REQUEST",
      "FETCH_MESSAGES",
      "LOADER_CLOSE",
    ]),
    moment,
    logIn() {
      let vm = this;
      let obj = {
        username: vm.username,
        tryies: 0,
        chance: 1,
        time: vm.moment().format(),
      };
      if (vm.timer) {
        clearInterval(vm.timer);
        vm.timer = null;
      }
      let auth_tryies = [];
      if (sessionStorage.getItem("auth_tryies")) {
        auth_tryies = JSON.parse(sessionStorage.getItem("auth_tryies"));
      }
      const found = auth_tryies.some((item) => item.username === vm.username);
      if (!found) {
        auth_tryies.push(obj);
        vm.authenticate();
      }
      if (found) {
        let user = auth_tryies.find((item) => item.username === vm.username);
        if (user.tryies <= 6) {
          // When still have time
          vm.authenticate();
          auth_tryies.find((item, index) => {
            if (item.username === vm.username) {
              let obj = {
                username: vm.username,
                tryies: item.tryies + 1,
                chance: item.chance,
                time: vm.moment().format(),
              };
              auth_tryies[index] = obj;
              vm.try_error_label = false;
            }
          });
        } else {
          let time = vm.moment(user.time);
          let time_left = moment().diff(time, "seconds");
          if (time_left > 30 * user.chance) {
            // When time end
            vm.authenticate();
            auth_tryies.find((item, index) => {
              if (item.username === vm.username) {
                let obj = {
                  username: vm.username,
                  tryies: 0,
                  chance: item.chance + 1,
                  time: vm.moment().format(),
                };
                auth_tryies[index] = obj;
                vm.try_error_label = false;
              }
            });
          } else {
            vm.try_error_label = true;
            vm.chance_time = 30 * user.chance;
            vm.timer = setInterval(() => {
              if (vm.chance_time > 0) {
                vm.chance_time =
                  30 * user.chance - moment().diff(time, "seconds");
              } else {
                clearInterval(vm.timer);
                vm.timer = null;
                vm.try_error_label = false;
              }
            }, 1000);
          }
        }
      }
      sessionStorage.setItem("auth_tryies", JSON.stringify(auth_tryies));
    },
    startProgressBar() {
      this.$store.dispatch("LOADER_START");
      this.$store.dispatch("LOADER_SUCCESS");
      this.$store.dispatch("LOADER_MESSAGE");
    },
    stopProgressBar() {
      this.$store.dispatch("LOADER_CLOSE");
    },
    authenticate() {
      let vm = this;
      vm.loading = true;
      vm.$store
        .dispatch("AUTH_REQUEST", {
          email: this.username,
          password: this.password,
        })
        .then((response) => {
          console.log(response.data);
          let auth_tryies = [];
          if (sessionStorage.getItem("auth_tryies")) {
            auth_tryies = JSON.parse(sessionStorage.getItem("auth_tryies"));
          }
          auth_tryies.find((item, index) => {
            if (item.username === vm.username) {
              auth_tryies.splice(index, 1);
              vm.try_error_label = false;
            }
          });
          sessionStorage.setItem("auth_tryies", JSON.stringify(auth_tryies));
          if (vm.remember_me) {
            vm.$localStorage.set(
              "logged_user_data",
              JSON.stringify(response.data)
            );
          }
          vm.loading = false;
          vm.$router.push({ path: "/" });
          if (response.data.activated === true) {
            if (response.data.account_type == 3) {
            }
          }
        })
        .catch((error) => {
          vm.loading = false;
        });
    },
    signInBySocial(sign_type) {
      let vm = this;
      vm.loading = true;
      sessionStorage.setItem("is_login", true);
      if (sign_type == "linkedin") {
        this.$store
          .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "google") {
        this.$store
          .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "facebook") {
        this.$store
          .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "microsoft") {
        this.$store
          .dispatch("AUTH_MICROSOFT_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-family: Amblas;
  overflow: hidden;
  background-size: contain;
  z-index: 999999;
  background-repeat: no-repeat !important;
  background-position: center;
}
.__container {
  position: relative;
  align-self: center;
  display: inline-block;
  @media (min-width: 300px) and (max-width: 630px) {
  }
  .form {
    display: flex;
    align-items: center;
    flex-direction: column;
    .logo {
      h2 {
        color: #1885ad !important;
        font-family: Amblas;
        font-weight: 800;
      }
      @media (min-width: 300px) and (max-width: 630px) {
        position: relative;
        top: -10px;
      }
      img {
        width: 70px;
        height: 75px;
      }
    }
    .login_form {
      margin-top: 20px;
      text-align: left;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }
      .label-password {
        margin-top: 30px;
      }
      .label {
        color: #000;
        font-weight: normal;
        font-size: 14px;
        margin-bottom: 5px;
        margin-left: 20px;
      }
      .error_input {
        border: 1px solid crimson !important;
        color: crimson;
      }
      .error-msg {
        color: crimson;
        text-align: left;
      }
      .input:focus {
        outline: none !important;
        box-shadow: none;
      }
      input[type="text"],
      input[type="password"] {
        width: 400px;
        padding: 10px;
        height: 45px;
        background-color: #ffffff;
        border: 1px solid #ccc;
        @media (min-width: 300px) and (max-width: 630px) {
          width: 300px;
        }
        border-radius: 5px;
        background-size: 20px 15px;
        background-origin: content-box;
        background-repeat: no-repeat;
        &:focus {
          outline: none;
        }
      }
      .forgot-password {
        margin-top: 10px;
      }
      .input-group {
        display: flex;
        margin-top: 30px;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        margin-bottom: 20px;
      }
    }
    .logo,
    .login_form {
      display: flex;
      flex-direction: column;
    }
    .banner {
      margin-top: 30px;
    }
    .banner span {
      font-size: 16px;
      color: #000000;
      font-weight: normal;
    }
    .banner h1 {
      font-weight: normal;
      text-align: center;
      font-size: 30px;
      color: #1ba5a4;
      margin-bottom: 1rem !important;
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 15px;
      .remember-me-input {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      .signup {
        color: #1885ad !important;
        margin-top: 10px;
        cursor: pointer;
        margin-bottom: 10px;
      }
      input[type="button"] {
        background: #1885ad;
        width: 400px;
        height: 45px;
        outline: none;
        border-radius: 5px;
        padding: 7px;
        color: #fff;
        text-align: center;
        @media (min-width: 300px) and (max-width: 630px) {
          width: 300px;
        }
      }
      input[type="checkbox"] {
        background-color: #ffffff;
        position: relative;
        top: -1px;
        margin-right: 5px;
      }
      .sign-in-up-option {
        color: #1ba5a4;
        font-weight: 800;
        margin-top: 20px;
        margin-bottom: 5px;
      }
      .loader {
        margin-top: 10px;
        img {
          width: 30px;
        }
      }
      .social-media-list {
        list-style: none;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        margin-top: 20px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: grid;
          grid-template-columns: 48% 48%;
          grid-gap: 10px;
        }
        li.linkedin {
          margin-right: 10px;
          a {
            display: flex;
            align-items: center;
            background: #fff;
            padding: 3px 7px;
            border-radius: 5px;
            span {
              margin-top: 2px;
              margin-left: 3px;
              color: #3773bb;
            }
          }
        }
        li.google {
          margin-right: 10px;
          a {
            display: flex;
            align-items: center;
            background: #fff;
            padding: 3px 7px;
            border-radius: 5px;
            span {
              margin-top: 2px;
              margin-left: 3px;
            }
          }
        }
        li.facebook {
          margin-right: 10px;
          a {
            display: flex;
            align-items: center;
            background: #4765a3;
            padding: 3px 7px;
            border-radius: 5px;
            span {
              margin-top: 2px;
              margin-left: 3px;
              color: #fff;
            }
          }
        }
        li.microsoft {
          margin-right: 10px;
          a {
            display: flex;
            align-items: center;
            background: #fff;
            padding: 3px 7px;
            border-radius: 5px;
            span {
              margin-top: 2px;
              margin-left: 3px;
              color: #000;
            }
          }
        }
      }
      .dont-have-account {
        color: #8f95a4;
        a {
          color: #0884af;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.login-pass-input {
  width: 400px;
  @media (min-width: 300px) and (max-width: 630px) {
    width: 300px;
  }
  input {
    width: 400px;
    padding: 10px;
    height: 45px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    @media (min-width: 300px) and (max-width: 630px) {
      width: 300px;
    }
    border-radius: 5px;
    background-size: 20px 15px;
    background-origin: content-box;
    background-repeat: no-repeat;
    &:focus {
      outline: none;
    }
  }
  .VuePassword__Meter {
    display: none !important;
  }
}
</style>

